import React, {Component} from 'react';
import {renderSelectPlayerCountsOptions} from 'components/organisms/team-name-stacking/team-stack-helper';
import {connect} from 'react-redux';
import Action from 'components/organisms/team-name-stacking/actions';

class TeamOptions extends Component {
    handleEnableButton() {
        const teamOptions = {...this.props.teamOptions};
        teamOptions.enabled = !teamOptions.enabled;

        this.props.dispatch(
            Action.setTeamOptions({
                teamName: this.props.teamName,
                teamOptions,
            }),
        );
    }

    onChangeMinPlayersValue(minPlayersCount) {
        const teamOptions = {...this.props.teamOptions};
        teamOptions.minPlayers = Number(minPlayersCount);

        if (teamOptions.minPlayers > teamOptions.maxPlayers) {
            teamOptions.maxPlayers = this.props.maxSingleTeamPlayers;
        }

        this.props.dispatch(
            Action.setTeamOptions({
                teamName: this.props.teamName,
                teamOptions,
            }),
        );
    }

    onChangeMaxPlayersValue(maxPlayersCount) {
        const teamOptions = {...this.props.teamOptions};
        teamOptions.maxPlayers = Number(maxPlayersCount);

        if (teamOptions.minPlayers > teamOptions.maxPlayers) {
            teamOptions.minPlayers = 0;
        }

        this.props.dispatch(
            Action.setTeamOptions({
                teamName: this.props.teamName,
                teamOptions,
            }),
        );
    }

    render() {
        const teamInfo = this.props.teamInfo;
        const teamName = this.props.teamName;
        const teamOptions = this.props.teamOptions;

        return (
            <div className={`team-limits-box ${teamOptions.enabled ? '' : 'disabled'}`}>
                <button
                    onClick={() => this.handleEnableButton()}
                    type="button"
                    className={`checkbox-btn ${teamOptions.enabled ? 'active' : ''}`}
                />
                <div className="team-box">
                    {teamInfo.logo ? <img src={teamInfo.logo} alt={teamName} /> : ''}
                    <span>{teamName}</span>
                </div>
                <div className="team-limits-player">
                    <label>Min</label>
                    <select
                        onChange={(e) => ::this.onChangeMinPlayersValue(e.target.value)}
                        className="form-control"
                        disabled={!teamOptions.enabled}
                        value={teamOptions.minPlayers}
                    >
                        {renderSelectPlayerCountsOptions(this.props.maxSingleTeamPlayers)}
                    </select>
                </div>
                <div className="team-limits-player">
                    <label>Max</label>
                    <select
                        onChange={(e) => ::this.onChangeMaxPlayersValue(e.target.value)}
                        className="form-control"
                        disabled={!teamOptions.enabled}
                        value={teamOptions.maxPlayers}
                    >
                        {renderSelectPlayerCountsOptions(this.props.maxSingleTeamPlayers)}
                    </select>
                </div>
            </div>
        );
    }
}

export default connect(() => ({}))(TeamOptions);
